import { useDialog } from "helper/customHook";
import ViewTable from "modules/DeclareLeave/components/CustomTable";
import { listFeedbackDataSelector } from "modules/DeclareLeave/redux/selector";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import pxToRem from "theme/base/pxToRem";
import {
  ApproveStatus,
  ApproveStatusValue,
  statusColor,
} from "modules/DeclareLeave/components/CustomCalendarTimeKeeping/const";

import { DIALOG } from "helper/enum/dialogEnum";
import EmptyState from "components/common/EmptyState";
import { formatDateStringToDDMMYYYY } from "helper/utils";
import SendFeedback from "modules/DeclareLeave/components/CustomCalendarTimeKeeping/components/Modals/SendFeedback";
import { PopoverAction } from "./PopoverAction";
import { TYPE_LEAVE } from "modules/DeclareLeave/redux/getReasonLeave";
import { setupFeedback } from "modules/DeclareLeave/redux/sendFeedback";
import { ConfirmModal } from "components/common/ConfirmModal";
import {
  deleteRequestStart,
  setDeleteRequestData,
} from "modules/DeclareLeave/redux/deleteRequest";
import { SCREEN } from "helper/roleChecker/Screens";
import moment from "moment";
import ResponseDetails from "modules/DeclareLeave/components/CustomCalendarTimeKeeping/components/Modals/ResponseDetail";
import { useNavigate, useParams } from "react-router-dom";
import pathRoutes from "routes/pathRoutes";
import { declareLeaveURL } from "modules/DeclareLeave/Pages/Main/DeclareLeaveContent/index";
import { memo } from "react";

export const ListFeedback = memo(() => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const data = useSelector(listFeedbackDataSelector);

  const sendFeedbackDialog = useDialog(DIALOG.SEND_FEEDBACK);
  const confirmDialog = useDialog(DIALOG.MODAL_CONFIRM);
  const viewFeedbackDetailDialog = useDialog(DIALOG.RESPONSE_DETAIL);

  const deleteRequest = () => {
    dispatch(
      deleteRequestStart({ tab: "feedback", screenCode: SCREEN.IP_016 })
    );
  };
  const columns = [
    {
      id: "createdDate",
      accessorKey: "createdDate",
      header: "Ngày tạo đơn",
      footer: (props) => props.column.id,
      cell: (info) => (
        <Typography
          sx={(theme) => ({
            fontSize: pxToRem(12),
            color: theme.palette.text.textPrimary,
            width: "100%",
            textAlign: "center",
          })}
        >
          {formatDateStringToDDMMYYYY(info.getValue())}
        </Typography>
      ),
      minSize: 120,
      pinPosition: "left",
    },
    {
      id: "date",
      accessorKey: "date",
      header: "Ngày giải trình",
      footer: (props) => props.column.id,
      cell: (info) => (
        <Typography
          sx={(theme) => ({
            fontSize: pxToRem(12),
            color: theme.palette.text.textPrimary,
            width: "100%",
            textAlign: "center",
          })}
        >
          {formatDateStringToDDMMYYYY(info.getValue())}
        </Typography>
      ),
      minSize: 120,
      pinPosition: "left",
    },
    {
      id: "type",
      accessorKey: "type",
      header: "Công làm việc",
      minSize: 120,
      pinPosition: "left",
      cell: (info) => {
        return (
          <Typography
            sx={(theme) => ({
              fontSize: pxToRem(12),
              color: theme.palette.text.textPrimary,
              width: "100%",
              textAlign: "center",
            })}
          >
            {info.getValue() === TYPE_LEAVE.FULL_DAY ? "Cả ngày" : "Nửa ngày"}
          </Typography>
        );
      },
    },
    {
      accessorKey: "description",
      header: "Lý do giải trình",
      cell: (info) => {
        const reasons = (info.getValue() ?? "").split("#") ?? [];
        return (
          <Box display={"flex"} flexDirection={"column"}>
            {reasons.map((type, index) => (
              <Typography
                key={index}
                sx={(theme) => ({
                  fontSize: pxToRem(12),
                  color: theme.palette.text.textPrimary,
                })}
              >
                {type}
              </Typography>
            ))}
          </Box>
        );
      },
      footer: (props) => props.column.id,
      minSize: 220,
    },
    {
      id: "approverName",
      accessorKey: "approverName",
      header: "Người phê duyệt",
      minSize: 160,
      pinPosition: "left",
    },
    {
      id: "refuseReason",
      accessorKey: "refuseReason",
      header: "Ghi chú",
      minSize: 160,
      pinPosition: "left",
    },
    {
      accessorKey: "confirmDate",
      header: () => "Ngày phản hồi",
      footer: (props) => props.column.id,
      cell: (info) => {
        return (
          <Typography
            sx={(theme) => ({
              fontSize: pxToRem(12),
              color: theme.palette.text.textPrimary,
              width: "100%",
              textAlign: "center",
            })}
          >
            {info.getValue()
              ? formatDateStringToDDMMYYYY(info.getValue())
              : "---"}
          </Typography>
        );
      },
      minSize: 125,
    },

    {
      accessorKey: "confirmStatus",
      header: "Trạng thái",
      footer: (props) => props.column.id,
      cell: (info) => {
        const status = info.getValue();
        return (
          <Typography
            sx={(theme) => ({
              fontWeight: 600,
              fontSize: pxToRem(12),
              color: statusColor(theme, status, "color"),
            })}
          >
            {ApproveStatus[status]}
          </Typography>
        );
      },
      minSize: 100,
    },
    // {
    //   id: "note",
    //   accessorKey: "note",
    //   header: "Ghi chú",
    //   minSize: 200,
    //   pinPosition: "left",
    // },
    {
      accessorKey: "action",
      header: "",

      cell: (info) => (
        <PopoverAction
          showAction={
            info.row.original.confirmStatus === ApproveStatusValue.PENDING &&
            info.row.original.editable
          }
          isDeletable={true}
          editable={true}
          editAction={(e) => {
            e.stopPropagation();
            sendFeedbackDialog.open();

            dispatch(
              setupFeedback({
                id: info.row.original.id,
                date: moment(info.row.original.date).format("DD/MM/YYYY"),
                reason: info.row.original.description,
                type: info.row.original.type,
                explainAllow: info.row.original.explainAllow,
              })
            );
          }}
          deleteAction={(e) => {
            e.stopPropagation();
            dispatch(setDeleteRequestData(info.row.original.id));
            confirmDialog.open();
          }}
        />
      ),
      minSize: 100,
    },
  ];

  const handleViewDetail = (idRecord: string) => {
    if (idRecord === id) {
      viewFeedbackDetailDialog.open();
    } else {
      navigate(
        `${pathRoutes.declareLeave.base}/${declareLeaveURL.orderLeave}/${declareLeaveURL.feedback}/${idRecord}`,
        { replace: true }
      );
    }
  };

  return (
    <>
      <ViewTable
        data={data}
        columns={columns}
        columnPinning={{
          left: [],
          right: ["action"],
        }}
        handleFetchMore={() => {}}
        messageEmpty={
          <EmptyState
            message="Chưa có đơn phản hồi nào"
            sx={(theme) => ({
              h6: {
                color: theme.palette.text.textSecondary,
              },
            })}
          />
        }
        handleOnClickedRow={(item) => handleViewDetail(item.id)}
        height={"auto"}
      />
      <SendFeedback />
      <ConfirmModal
        title="Bạn có muốn xóa đơn này"
        styleTitle={{
          width: pxToRem(270),
        }}
        buttonApprove="Xóa đơn"
        buttonReject="Hủy"
        buttonApproveProps={{
          color: "error",
        }}
        buttonRejectProps={{
          variant: "blur",
          sx: {
            backgroundColor: "#E6E6E6",
            color: "#000000",
          },
        }}
        onApprove={deleteRequest}
      />
      <ResponseDetails />
    </>
  );
});
